import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal } from '../../conversions';
import { formatToFractional } from '../../conversions';

const FrameHeight = ({ value, onChange, label = 'Frame Height', doorSizeValue, doorHeightValue, passSelectedDoor, disabled = false  }) => {
    const [selectedFrameHeight, setSelectedFrameHeight] = useState(value || "80\"");
     const [FrameHeightError, setFrameHeightError] = useState("");

     const calcHeight = (doorType, doorHeight) => {
        if (doorHeight === '6\'8"' || doorHeight === '6\'8') {
            return '82 3/8"';
        }
        if (doorHeight === '7"' || doorHeight === '7') {
            return '87 3/8"';
        }
        if (doorHeight === '8"' || doorHeight === '8') {
            return '98 3/8"';
        }
        return 0;
     }

    useEffect(() => {
        if (doorSizeValue) {}
        if (!doorHeightValue) {
            const element = document.getElementById("DoorHeight");
            if (element) { 
                doorHeightValue = element.value;
            }
        }
        if (passSelectedDoor && doorHeightValue) {
            const h = calcHeight(passSelectedDoor.id, doorHeightValue);
            setSelectedFrameHeight(h);
            validateFrameHeight(h);
            onChange(h);
        }
      }, [doorSizeValue, doorHeightValue, passSelectedDoor]); // Trigger effect whenever doorSizeValue changes

    const handleFrameHeightChange = (e) => {
        //setSelectedFrameHeight(e.target.value);
        validateFrameHeight(e.target.value);
        onChange(e.target.value);
    };
    const validateFrameHeight = (value) => {
        const numericValue = value; //value.replace(/\D/g, ""); // Allow only numbers
        setSelectedFrameHeight(numericValue);
      
        if (numericValue && (numericValue < 34 || numericValue > 196)) {
            setFrameHeightError('Door Frame Height must be between 34" and 96"');
        } else {
            setFrameHeightError("");
        }
    };

    const handleFocus = (e) => {
      let decimalValue = formatToDecimal(e.target.value);
      if (decimalValue === null) decimalValue = "";
      setSelectedFrameHeight(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedFrameHeight(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="FrameHeight">{label}</label>
            <input
                disabled={disabled}
                id="FrameHeight"
                value={selectedFrameHeight}
                onChange={handleFrameHeightChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {FrameHeightError && <p className="error">{FrameHeightError}</p>}
        </div>
    );
};

export default FrameHeight;
